// extracted by mini-css-extract-plugin
export var bubble = "_3e-0";
export var container = "_3e-f";
export var contrastBorder = "_3e-g";
export var greyOut = "_3e-2";
export var initialsColor0 = "_3e-3";
export var initialsColor1 = "_3e-4";
export var initialsColor10 = "_3e-d";
export var initialsColor11 = "_3e-e";
export var initialsColor2 = "_3e-5";
export var initialsColor3 = "_3e-6";
export var initialsColor4 = "_3e-7";
export var initialsColor5 = "_3e-8";
export var initialsColor6 = "_3e-9";
export var initialsColor7 = "_3e-a";
export var initialsColor8 = "_3e-b";
export var initialsColor9 = "_3e-c";
export var initialsWrapper = "_3e-1";
export var large = "_3e-l";
export var medium = "_3e-k";
export var mediumSmall = "_3e-j";
export var mediumSmallMedium = "_3e-o";
export var micro = "_3e-h";
export var small = "_3e-i";
export var tiny = "_3e-n";
export var xTiny = "_3e-m";